var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-sheet',{staticClass:"text-h6 font-weight-black text-center",attrs:{"rounded":""}},[_c('v-card',{staticClass:"score-card"},[_vm._v(_vm._s(_vm.compute_score.toFixed(1)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }